import React, { FC } from 'react';
import { TimePeriodMenuProps } from '@v2/pages/machines/common/components/Header/MachinesHeaderV2/types';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { View } from 'react-native';
import { navigationLevels } from '@v2/pages/machines/common/constants';
import { TimePeriod } from '@v2/pages/machines/common/enums';
import { NavLink } from './NavLink';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

const TimePeriodMenu: FC<TimePeriodMenuProps> = ({ rowStyles, shouldHideYear, shouldDisplayEightWeeks }) => {
  const { updateTimePeriod, isPerformanceSubScreen } = useHandleNavigationMachinesHeader();
  const { timePeriod: _timePeriod } = useHandleParams();

  return (
    <View style={rowStyles}>
      {Object.entries(navigationLevels.timePeriod).map(([timePeriod, title]) => {
        if (shouldHideYear && timePeriod === TimePeriod.YEAR) return null;
        if (timePeriod === TimePeriod.EIGHT_WEEKS && !shouldDisplayEightWeeks && !isPerformanceSubScreen) return null;
        const timePeriodTestIDs: Record<string, string> = {
          [TimePeriod.DAY]: TEST_IDS.machinesHeader.timePeriodDay,
          [TimePeriod.WEEK]: TEST_IDS.machinesHeader.timePeriodWeek,
          [TimePeriod.MONTH]: TEST_IDS.machinesHeader.timePeriodMonth,
          [TimePeriod.YEAR]: TEST_IDS.machinesHeader.timePeriodYear,
          [TimePeriod.EIGHT_WEEKS]: TEST_IDS.machinesHeader.timePeriodEightWeeks,
        };
        return <NavLink key={timePeriod} title={title} selected={_timePeriod === timePeriod} onPress={() => updateTimePeriod(timePeriod)} testID={timePeriodTestIDs[timePeriod]} capitalize />;
      })}
    </View>
  );
};

export { TimePeriodMenu };
